module.exports = __webpack_public_path__ + "img/shopping-icon.41831e07.png";